import { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import {
  Home, ShoppingCart, Boxes, Truck, DollarSign, PieChart, UserCircle, Wrench,
  FileText, Users, Package2, BarChart3, ClipboardList,
  Wallet, Receipt, LineChart, Landmark,
  TrendingUp, UserCog, ShieldCheck, Settings as SettingsIcon, History,
  ChevronDown, ChevronRight, LogOut, Sprout, RefreshCw, PieChart as ReportsIcon,
  Tractor, QrCode,
  Layers, Building2, History as HistoryIcon, Package2 as SacariaIcon, MapPin,
  FileCheck2, Plus, Database, CreditCard, Camera, BookUser,
} from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

const SECTIONS = [
  { id: "inicio", label: "Início", icon: Home, items: [
    { label: "Dashboard", icon: Home, path: "/dashboard" },
  ]},
  { id: "cadastros", label: "Cadastros", icon: BookUser, items: [
    { label: "Motoristas", icon: Truck, path: "/motoristas", perm: "can_manage_suppliers" },
    { label: "Fornecedores", icon: Users, path: "/suppliers", perm: "can_manage_suppliers" },
    { label: "Clientes", icon: Users, path: "/clients", perm: "can_manage_clients" },
  ]},
  { id: "compras", label: "Compras", icon: ShoppingCart, items: [
    { label: "Notas Fiscais", icon: FileText, path: "/invoices", perm: "can_create_invoice" },
    { label: "Beneficiamento", icon: Tractor, path: "/invoices?status=em_beneficiamento", perm: "can_do_beneficiamento" },
    { label: "Preços & Custos", icon: DollarSign, path: "/admin/benef-precos", perm: "can_access_admin" },
    { label: "Fornecedores", icon: Users, path: "/suppliers", perm: "can_manage_suppliers" },
    { label: "Sacarias", icon: SacariaIcon, path: "/sacarias", perm: "can_manage_sacaria" },
    { label: "Estoque Sacaria", icon: SacariaIcon, path: "/sacarias/estoque", perm: "can_manage_sacaria" },
  ]},
  { id: "terceiros", label: "Beneficiamento a Terceiros", icon: Users, items: [
    { label: "NFs de Terceiros", icon: FileText, path: "/terceiros/nfs", perm: "can_manage_terceiros" },
    { label: "Nova NF Terceiros", icon: Plus, path: "/terceiros/nfs/new", perm: "can_manage_terceiros" },
    { label: "Estoque de Terceiros", icon: Layers, path: "/terceiros/pallets", perm: "can_manage_terceiros" },
    { label: "Retiradas", icon: Truck, path: "/terceiros/retiradas", perm: "can_manage_terceiros" },
    { label: "Relatório por Cliente", icon: BarChart3, path: "/terceiros/relatorio-cliente", perm: "can_manage_terceiros" },
  ]},
  { id: "estoque", label: "Estoque", icon: Boxes, items: [
    { label: "Lotes Disponíveis", icon: Boxes, path: "/stock", perm: "can_create_shipment" },
    { label: "Pallets", icon: Layers, path: "/pallets", perm: "can_create_shipment" },
    { label: "Conferência de Estoque", icon: QrCode, path: "/estoque/conferencia", perm: "can_create_shipment" },
    { label: "Rebeneficiamento", icon: RefreshCw, path: "/estoque/rebeneficiamento", perm: "can_do_beneficiamento" },
  ]},
  { id: "vendas", label: "Vendas", icon: Truck, items: [
    { label: "Expedição", icon: QrCode, path: "/expedicao", perm: "can_create_shipment" },
    { label: "Saídas", icon: Truck, path: "/shipments", perm: "can_create_shipment" },
    { label: "Clientes", icon: Users, path: "/clients", perm: "can_manage_clients" },
  ]},
  { id: "faturamento", label: "Faturamento", icon: FileCheck2, perm: "can_issue_nfe", items: [
    { label: "NF-e (Focus)", icon: FileCheck2, path: "/faturamento" },
  ]},
  { id: "financeiro", label: "Financeiro", icon: DollarSign, perm: "can_access_financial", items: [
    { label: "Visão Geral", icon: Wallet, path: "/finance" },
    { label: "Contas a Pagar", icon: Wallet, path: "/finance/payable" },
    { label: "Contas a Receber", icon: Receipt, path: "/finance/receivable" },
    { label: "Fretes Motoristas", icon: Truck, path: "/finance/fretes" },
    { label: "Fluxo de Caixa", icon: LineChart, path: "/finance/cashflow" },
    { label: "Recorrentes", icon: RefreshCw, path: "/finance/recurring" },
  ]},
  { id: "rh", label: "RH", icon: Users, perm: "can_manage_employees", items: [
    { label: "Funcionários", icon: Users, path: "/rh/funcionarios" },
    { label: "Folha de Pagamento", icon: Wallet, path: "/rh/folha" },
    { label: "Ponto Eletrônico", icon: QrCode, path: "/rh/ponto" },
  ]},
  { id: "relatorios", label: "Relatórios", icon: ReportsIcon, perm: "can_access_reports", items: [
    { label: "KPIs", icon: BarChart3, path: "/reports?tab=kpis" },
    { label: "DRE", icon: TrendingUp, path: "/reports?tab=dre" },
    { label: "P&L por Unidade", icon: MapPin, path: "/reports?tab=by-unidade" },
    { label: "P&L por Vendedor", icon: UserCircle, path: "/reports?tab=by-vendedor" },
    { label: "P&L por NF", icon: FileText, path: "/reports?tab=by-invoice" },
    { label: "P&L por Nota de Venda", icon: FileText, path: "/reports?tab=by-shipment" },
    { label: "P&L por Cliente", icon: Users, path: "/reports?tab=by-client" },
    { label: "Contas por Categoria", icon: Layers, path: "/reports?tab=by-category" },
    { label: "Custo por Saco", icon: DollarSign, path: "/reports?tab=custo-por-saco" },
    { label: "Sacos Maquinados", icon: Boxes, path: "/reports?tab=sacos-maquinados" },
    { label: "Saídas por Unidade", icon: Truck, path: "/reports?tab=saidas-por-unidade" },
    { label: "Fechamento Semanal", icon: LineChart, path: "/reports?tab=weekly" },
    { label: "Terceiros (Top Clientes)", icon: Users, path: "/reports?tab=terceiros" },
  ]},
  { id: "admin", label: "Configurações", icon: Wrench, items: [
    { label: "Empresa", icon: Building2, path: "/company", perm: "can_access_admin" },
    { label: "Permissões", icon: ShieldCheck, path: "/settings", perm: "can_access_settings" },
    { label: "Auditoria", icon: HistoryIcon, path: "/audit", adminOnly: true },
    { label: "Backup", icon: Database, path: "/backup", adminOnly: true },
    { label: "Modo Demo", icon: Camera, path: "/modo-demo", adminOnly: true },
    { label: "Assinatura", icon: CreditCard, path: "/assinatura", adminOnly: true },
  ]},
];

function pathMatches(currentPath, currentSearch, itemPath) {
  // Extrai o pathname e a query do it.path (ex: "/reports?tab=kpis")
  const [ipath, iquery = ""] = itemPath.split("?");
  const pathEq = currentPath === ipath || (ipath !== "/" && currentPath.startsWith(ipath + "/"));
  if (!pathEq) return false;
  if (!iquery) return true;
  // Comparar por chave/valor da query (ordem-independente e sem match em prefix)
  const iparams = new URLSearchParams(iquery);
  const cparams = new URLSearchParams(currentSearch || "");
  for (const [k, v] of iparams) {
    if (cparams.get(k) !== v) return false;
  }
  return true;
}

export default function Sidebar() {
  const { user, logout } = useAuth();
  const loc = useLocation();
  const isAdmin = user?.role === "admin";

  const visibleSections = SECTIONS.filter((s) => {
    if (s.adminOnly && !isAdmin) return false;
    if (s.perm && !isAdmin && !user?.permissions?.[s.perm]) return false;
    // Esconde a seção inteira quando nenhum item é visível para o usuário
    if (!isAdmin) {
      const hasVisibleItem = s.items.some((it) => {
        if (it.adminOnly) return false;
        if (it.perm && !user?.permissions?.[it.perm]) return false;
        return true;
      });
      if (!hasVisibleItem) return false;
    }
    return true;
  });

  // Se estiver em /reports sem ?tab, aba padrão é "kpis"
  const effSearch = (loc.pathname === "/reports" && !loc.search) ? "?tab=kpis" : loc.search;

  // open: section that has the active route is open by default
  const initialOpen = visibleSections.find((s) =>
    s.items.some((it) => pathMatches(loc.pathname, effSearch, it.path))
  )?.id || "inicio";
  const [open, setOpen] = useState(initialOpen);

  const toggle = (id) => setOpen((o) => (o === id ? null : id));

  const initials = (user?.name || user?.email || "?").slice(0, 1).toUpperCase();

  return (
    <aside className="hidden md:flex flex-col w-[260px] bg-sidebar fixed left-0 top-0 bottom-0 print:hidden border-r border-black/15">
      {/* Logo */}
      <div className="px-5 pt-5 pb-4 border-b border-white/10 mb-2">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-md bg-sidebar-accent flex items-center justify-center">
            <Sprout className="text-sidebar" size={20} />
          </div>
          <div className="leading-none">
            <div className="font-heading font-extrabold text-[18px] tracking-[2px] text-sidebar-accent">CEBOLAS</div>
            <div className="font-heading font-bold text-[12px] tracking-[3px] text-[#D9D3C3] mt-0.5">SERENATA</div>
          </div>
        </div>
        <div className="text-[10px] text-[#8BA89A] mt-2 tracking-wider uppercase">Sistema de gestão</div>
      </div>

      {/* Sections accordion */}
      <nav className="flex-1 overflow-y-auto px-1 py-2">
        {visibleSections.map((sec) => {
          const isOpen = open === sec.id;
          const hasActive = sec.items.some((it) => pathMatches(loc.pathname, effSearch, it.path));
          return (
            <div key={sec.id} className="mb-0.5">
              <button
                type="button"
                onClick={() => toggle(sec.id)}
                data-testid={`section-${sec.id}`}
                className={`w-full flex items-center gap-2.5 px-4 py-2.5 transition-colors ${
                  hasActive || isOpen ? "bg-white/5" : "hover:bg-white/5"
                }`}
              >
                <sec.icon size={16} className={hasActive ? "text-sidebar-accent" : "text-[#A8C4B8]"} />
                <span className={`flex-1 text-left text-[13px] font-bold uppercase tracking-[0.5px] ${
                  hasActive ? "text-sidebar-accent" : "text-[#A8C4B8]"
                }`}>{sec.label}</span>
                {isOpen
                  ? <ChevronDown size={14} className="text-[#A8C4B8]" />
                  : <ChevronRight size={14} className="text-[#A8C4B8]" />
                }
              </button>
              {isOpen && (
                <div className="py-1">
                  {sec.items.filter((it) => {
                    if (it.adminOnly && !isAdmin) return false;
                    if (it.perm && !isAdmin && !user?.permissions?.[it.perm]) return false;
                    return true;
                  }).map((it) => {
                    const active = pathMatches(loc.pathname, effSearch, it.path);
                    return (
                      <NavLink
                        key={it.path}
                        to={it.path}
                        data-testid={`nav-${it.path.replace(/\//g, "-").slice(1) || "root"}`}
                        className={`flex items-center gap-2.5 mx-2 ml-4 my-0.5 px-3 py-2.5 rounded-md text-[13px] transition-colors ${
                          active
                            ? "bg-sidebar-active text-white font-semibold"
                            : "text-[#A8C4B8] hover:bg-white/5 hover:text-white"
                        }`}
                      >
                        <it.icon size={14} />
                        <span>{it.label}</span>
                      </NavLink>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })}
      </nav>

      {/* User box */}
      <div className="border-t border-white/10 p-4 flex items-center gap-2.5">
        <div className="w-9 h-9 rounded-full bg-sidebar-accent flex items-center justify-center">
          <span className="text-sidebar font-bold text-base">{initials}</span>
        </div>
        <div className="flex-1 min-w-0 leading-tight">
          <div className="text-[13px] font-semibold text-white truncate">{user?.name || user?.email}</div>
          <div className="text-[11px] text-[#8BA89A] capitalize truncate">{user?.role}</div>
        </div>
        <button
          onClick={logout}
          data-testid="sidebar-logout-button"
          className="p-2 rounded-md bg-white/10 hover:bg-white/20 transition-colors text-white"
          title="Sair"
        >
          <LogOut size={14} />
        </button>
      </div>
    </aside>
  );
}
